import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { Customer } from 'src/types/customer';
import { ODataResponse } from 'src/types/oDataResponse';
import { get } from './Api';

async function getCustomers(filter: State): Promise<ODataResponse<Customer>> {
  return get<ODataResponse<Customer>>(`/odata/customer?${toODataString(filter, { utcDates: false })}&$count=true`);
}

async function getCustomersMinimal(filter: State): Promise<ODataResponse<Customer>> {
  return get<ODataResponse<Customer>>(`/odata/customer/GetMinimal()?${toODataString(filter, { utcDates: false })}`);
}

async function getCustomer(customerNumber: string): Promise<Customer> {
  return get<Customer>(`/customer/${customerNumber}`);
}

export default {
  getCustomersMinimal,
  getCustomers,
  getCustomer,
};
